import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';

interface RoleRouteProps {
  roles: string[];
  children: React.ReactNode;
  fallbackPath?: string;
}

export const RoleRoute: React.FC<RoleRouteProps> = ({ roles, children, fallbackPath = '/tickets' }) => {
  const { user, loading } = useAuth();
  const currentRole = String(user?.role || '').trim().toLowerCase();
  const allowed = roles.map((role) => String(role || '').trim().toLowerCase()).includes(currentRole);

  if (loading) return null;
  if (!allowed) return <Navigate to={fallbackPath} replace />;
  return <>{children}</>;
};
